import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog, DialogContentText, Stack } from "@mui/material";
import React from "react";

import infoIconYellow from "../../assets/images/common/infoIconYellow.svg";

const LogoutModal = ({ isLoggingOut, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={true}
      onClose={onCancel}
      sx={{ padding: "15px" }}
      className="dt-ta-logout-modal"
    >
      <Stack direction="column" sx={{ width: "400px" }} p={2}>
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <img src={infoIconYellow} alt="info" />
          <CloseIcon onClick={onCancel} sx={{ cursor: "pointer" }} />
        </Stack>
        <Stack className="dt-ta-logout-modal-info-stack">
          <DialogContentText className="dt-ta-logout-modal-info1">
            <strong>Logout!</strong>
          </DialogContentText>
          <DialogContentText>
            Are your sure you want to logout?
          </DialogContentText>
        </Stack>
        <Stack spacing={2} direction="row">
          <Button
            className="dt-ta-prog-del-modal-btns-out"
            variant="outlined"
            onClick={onCancel}
          >
            No
          </Button>
          <Button
            className="dt-ta-prog-del-modal-btns-filled-t2"
            variant="contained"
            disabled={isLoggingOut}
            onClick={onConfirm}
          >
            {isLoggingOut ? (
              <div className="dot-flashing dot-flashing-t1 dt-ta-login-cta-ldr"></div>
            ) : (
              <span>Yes</span>
            )}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default LogoutModal;
